import { AccessGate } from '../components/access/AccessGate';

export const PageNotFound = () => <AccessGate reason={{ code: 'NOT_FOUND', message: '' }} />;
